import './styles.scss'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Modal } from 'reactstrap'
import DatePicker, { Calendar } from 'react-multi-date-picker'
import InputIcon from "react-multi-date-picker/components/input_icon"

import { gregorian_spanish, gregorian_german, gregorian_french } from './locales'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const CalendarPicker = ({
  mode,
  initialValues,
  size,
  multipleSelection,
  onChange,
  className,
  classNameCalendar,
  classNameInput,
  modalOptions,
  rangeSelection=false
}) => {
  const user = useSelector(store => store.user)
  const [dates, setDates] = useState(initialValues || [])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const locale = user.locale === 'de'
    ? gregorian_german
    : user.locale === 'fr'
      ? gregorian_french
      : gregorian_spanish

  const handleSave = () => {
    if (mode === 'modal') setIsSubmitting(true)

    if (onChange) {
      if (Array.isArray(dates) && dates.length)
        onChange(dates.map(d => d.toString()))
      else {
        onChange(dates.toString())
      }
    }

    if (mode === 'modal') {
      modalOptions.toggle()
      setIsSubmitting(false)
    }
  }

  const calendarRender = () => {
    if (size === 'normal') {
      if(rangeSelection)
        return(
          <Calendar
            className={`calendar-style ${classNameCalendar ? classNameCalendar : ''}`}
            value={dates}
            onChange={setDates}
            locale={locale}
            format='YYYY-MM-DD'
            shadow={false}
            weekStartDayIndex={1}
            range
            rangeHover
            rangeHighlight={false}
          />
        )
      return (
        <Calendar
          className={`calendar-style ${classNameCalendar ? classNameCalendar : ''}`}
          value={dates}
          onChange={setDates}
          locale={locale}
          format='YYYY-MM-DD'
          shadow={false}
          weekStartDayIndex={1}
          multiple={multipleSelection}
          showOtherDays
        />
      )
    }

    if (size === 'small') {
      return (
        <DatePicker
          className={`picker-style ${classNameInput ? classNameInput : ''}`}
          render={<InputIcon/>}
          value={dates}
          onChange={setDates}
          locale={locale}
          format='YYYY-MM-DD'
          weekStartDayIndex={1}
          multiple={multipleSelection}
        />
      )
    }

    return null
  }

  if (mode === 'modal') {
    return (
      <Modal
        centered
        id={modalOptions.modalId ? modalOptions.modalId : 'calendarPickerModal'}
        isOpen={modalOptions.isOpen}
        toggle={modalOptions.toggle}
        contentClassName={`
          calendar-picker-modal
          ${!modalOptions.header && !modalOptions.buttons ? 'calendar-picker-modal--slim' : null}
          ${className ? className : ''}
        `}
      >
        {modalOptions.header && (
          <div className='calendar-picker-modal__header'>
            <div className='calendar-picker-modal__header-title-container'>
              {modalOptions.header?.title && <h1 className='calendar-picker-modal__header-title'>{modalOptions.header?.title}</h1>}
              <figure className='calendar-picker-modal__close-icon' onClick={modalOptions.toggle}>
                <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' />
              </figure>
            </div>
            {modalOptions.header?.subtitle && <p className='calendar-picker-modal__header-subtitle'>{modalOptions.header?.subtitle}</p>}
          </div>
        )}
        <div className ='calendar-picker-modal__body'>
          {calendarRender()}
        </div>
        {modalOptions.buttons && (
          <div className='calendar-picker-modal__footer'>
            <div className='calendar-picker-modal__buttons'>
              <Button secondary value={I18n.t('dashboard_save')} onClick={handleSave} isSubmitting={isSubmitting}/>
              <Button value={I18n.t('dashboard_cancel')} onClick={modalOptions.toggle}/>
            </div>
          </div>
        )}
      </Modal>
    )
  } else {
    return (
      <div className='calendar-picker'>
        {calendarRender()}
      </div>
    )
  }
}

CalendarPicker.defaultProps = {
  mode: '',
  initialValues: [],
  size: 'normal',
  multipleSelection: false,
  onChange: null,
  className: '',
  classNameCalendar: '',
  modalOptions: {}
}

export default CalendarPicker
